import { Field } from '../Field'

import * as styles from './FieldStackedLabel.module.css'

function FieldStackedLabel({
  className = styles.FieldStackedLabel,
  fieldInputClassName = styles.fieldStackedInput,
  labelClassName = styles.label,
  labelTextProps,
  ...restProps
}) {
  return (
    <Field
      {...restProps}
      className={className}
      fieldInputClassName={fieldInputClassName}
      labelClassName={labelClassName}
      labelTextProps={{
        ...labelTextProps,
        className: labelTextProps?.className || styles.fieldStackedLabelText,
      }}
    />
  )
}

export default FieldStackedLabel
